import { Wrapper } from '@american-autonomy/ag-ui';

import WithArrow from 'components/WithArrow';
import NavigationText from 'components/text/NavigationText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const OrganizationDropdownMenuButton: FunctionComponent<Props> = ({
    className = '',
    currentOrganizationName,
    testId = TEST_ID
}) => (
    <Wrapper className={styles.organizationDropdownMenuButton}>
        <WithArrow className={styles.withArrow}>
            <NavigationText className={className} testId={testId}>
                {currentOrganizationName}
            </NavigationText>
        </WithArrow>
    </Wrapper>
);

export default OrganizationDropdownMenuButton;
